import 'css-chunksrc/client/scenes/optimizedGantt/calendar/months/month/styles.scss';export default {
  "month": "_month_svhum_1",
  "monthName": "_monthName_svhum_16",
  "year": "_year_svhum_31",
  "weeks": "_weeks_svhum_35",
  "cutOffWeek": "_cutOffWeek_svhum_40",
  "week": "_week_svhum_35",
  "weekNbr": "_weekNbr_svhum_57",
  "even": "_even_svhum_61",
  "odd": "_odd_svhum_65"
};